import React from "react";
import { observer } from "mobx-react";
import { ReportTypeCreateStore } from "../../store";
import { ReportTypeCreateForm } from "./ReportTypeCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type ReportTypeCreateProps = {
  reportTypeCreateStore: ReportTypeCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const ReportTypeCreate: React.FC<ReportTypeCreateProps> = observer(
  ({ reportTypeCreateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={reportTypeCreateStore.isSaving} />
        <ReportTypeCreateForm
          reportTypeCreateStore={reportTypeCreateStore}
          nameError={reportTypeCreateStore.errors.name?.message}
          onNameChange={(value: string) => {
            reportTypeCreateStore.setNameValue(value);
          }}
          name={reportTypeCreateStore.entityValues.name}
          descriptionError={reportTypeCreateStore.errors.description?.message}
          onDescriptionChange={(value: string) => {
            reportTypeCreateStore.setDescriptionValue(value);
          }}
          description={reportTypeCreateStore.entityValues.description}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={reportTypeCreateStore.isProcessing}
          onSave={() => reportTypeCreateStore.saveNewReportType()}
          onCancel={() => reportTypeCreateStore.cancelNewReportType()}
        />
        <ErrorDialog
          open={reportTypeCreateStore.errorDialogOpened}
          title={reportTypeCreateStore.errorTitle}
          description={reportTypeCreateStore.errorDescription}
          onClose={() => reportTypeCreateStore.closeErrorDialog()}
        />
      </>
    );
  }
);
